import { clear, get, set } from '@separate/utilities/tokens';

const INELIGIBLE_STATES = ['UT', 'VT', 'WA'];
const PREMIUM_REDIRECT = 'premiumRedirect';
const PAY_DUE_STATUSES = [
  'past_due',
  'incomplete_expired',
];


export function isStateEligible(state) {
  return !INELIGIBLE_STATES.includes(state);
}

export function isSubscriptionPastDue(subscription) {
  return PAY_DUE_STATUSES.includes(subscription?.status);
}

// Similarly here, I _believe_ active is the only possible status for being in good standing.  We want true here
// as long as the subscription is live, whether in good standing or not.
export function isSubscriptionActive(subscription) {
  return (
    subscription?.status === 'active' || isSubscriptionPastDue(subscription)
  );
}

export function isSubscriptionLegacy(subscription) {
  return !subscription?.last4 && isSubscriptionActive(subscription);
}

export function clearPremiumRedirect() {
  clear(PREMIUM_REDIRECT);
}

export function getPremiumRedirect() {
  return get(PREMIUM_REDIRECT);
}

export function setPremiumRedirect(url) {
  set(PREMIUM_REDIRECT, url, null);
}
